import { Request } from '@/http/request'

export function dropDownList(parameter: any){
  return Request.axiosInstance.post('/open/area/drop-down-list', parameter)
}
export function dropDownTreeList(parameter: any){
  return Request.axiosInstance.post('/open/area/drop-down-tree-list', parameter)
}

export default { dropDownList ,dropDownTreeList}